import { Grid } from '@mui/material'
import { PierDto } from '@storage/app/api'
import { PiersListItem } from './PiersListItem'

interface Props {
  items: PierDto[]
  canWrite: boolean
  onDeleteItem: (id: string) => Promise<void> | void
  onEditItem: (id: string) => Promise<void> | void
}

export const PiersList = ({ items, canWrite, onDeleteItem, onEditItem }: Props) => {
  return (
    <Grid container spacing={1.5}>
      {items.map(item => (
        <Grid
          key={item.id}
          size={{
            xs: 6,
            md: 3,
          }}
        >
          <PiersListItem
            item={item}
            canWrite={canWrite}
            onDelete={onDeleteItem}
            onEdit={onEditItem}
          />
        </Grid>
      ))}
    </Grid>
  )
}
